import {
  IconButton,
  ListItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
  Typography,
  CircularProgress,
} from "@material-ui/core"
import { Download, File, FileText, Image, Archive, Trash, Video } from "react-feather"
import { StorageFileViewModel } from "../api/storage-file"

const FileListItem = ({
  file,
  canDelete,
  onDelete,
  onDownload,
  loadingDelete,
  loadingDownload,
  onOpenInBrowser,
  divider,
}: FileListItemProps) => {
  const fileIcon = getFileIcon(file.contentType)

  return (
    <ListItem
      divider={divider}
      style={{
        height: 48,
      }}
    >
      <ListItemIcon>{fileIcon}</ListItemIcon>

      <ListItemText
        primary={
          <Typography variant="body2" noWrap onClick={() => onOpenInBrowser(file.id)} style={{ cursor: "pointer" }}>
            {file.filename}
          </Typography>
        }
        secondary={formatFileSize(file.size)}
      />

      <Tooltip title="Download">
        <IconButton color="inherit" disabled={loadingDownload} size="small" onClick={() => onDownload(file.id)}>
          {loadingDownload ? <CircularProgress size={16} /> : <Download size={18} />}
        </IconButton>
      </Tooltip>

      {canDelete ? (
        <Tooltip title="Delete">
          <IconButton
            color="inherit"
            disabled={loadingDelete}
            size="small"
            style={{ marginLeft: 4 }}
            onClick={() => onDelete(file.id)}
          >
            {loadingDelete ? <CircularProgress size={16} /> : <Trash size={18} />}
          </IconButton>
        </Tooltip>
      ) : null}
    </ListItem>
  )
}

export default FileListItem

const getFileIcon = (contentType?: string) => {
  if (!contentType) return <File size={18} />

  if (contentType.startsWith("image/")) {
    return <Image size={18} />
  }

  if (contentType.startsWith("text/") || contentType.includes("word") || contentType.includes("pdf")) {
    return <FileText size={18} />
  }

  if (contentType.includes("video")) {
    return <Video size={18} />
  }

  if (contentType.includes("zip") || contentType.includes("compressed") || contentType.includes("rar")) {
    return <Archive size={18} />
  }

  return <File size={18} />
}

const formatFileSize = (bytes?: number) => {
  if (!bytes || bytes <= 0) return "0 B"
  const sizes = ["B", "KB", "MB", "GB"]
  const i = Math.floor(Math.log(bytes) / Math.log(1024))
  return `${(bytes / Math.pow(1024, i)).toFixed(1)} ${sizes[i]}`
}

type FileListItemProps = {
  file: StorageFileViewModel
  canDelete: boolean
  onDelete: (id: string) => void
  onDownload: (id: string) => void
  onOpenInBrowser: (id: string) => void
  loadingDelete?: boolean
  loadingDownload?: boolean
  divider?: boolean
}
